var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.backgroundColor
			? 'background-color: ' + _vm.backgroundColor + ' !important;'
			: ''),attrs:{"dark":"","app":"","data-iframe-height":""}},[_c('v-main',{staticClass:"transparent"},[_c('router-view'),_c('div',{attrs:{"id":"version","version":_vm.version}})],1),_c('CheckoutDrawer'),(!_vm.inApp && _vm.hasOrganization && !_vm.minimalFooter)?_c('v-footer',{class:_vm.dark ? 'pt-5 pb-5' : 'grey lighten-3 pt-5 pb-5'},[_c('Footer')],1):(
			!_vm.inApp && _vm.hasOrganization && _vm.minimalFooter && _vm.isInitialized
		)?_c('v-footer',{staticClass:"transparent pb-5"},[_c('MinimalFooter')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }